import { type Context, createContext } from 'react';

import type { MessageContainerProps } from '../MessageContainer.types.js';

/** @internal */
export type MessageContainerContext = {
  variant: Required<MessageContainerProps['variant']>;
};

/** @internal */
export const MessageContainerContext: Context<MessageContainerContext> =
  createContext<MessageContainerContext>({
    variant: 'neutral',
  });
